export const HEADER_COLOR = '#D3D3D3';
export const OUTER_BORDER_COLOR = '#1476ED';
export const OUTER_BORDER_WIDTH = 0.5;
export const INNER_BORDER_COLOR = "#000000";
export const INNER_BORDER_WIDTH = 0.25;

export const PAGE_BORDER_WIDTH = 6;
export const FULL_WIDTH = 216 - PAGE_BORDER_WIDTH * 2;
export const FULL_HEIGHT = 355;
export const GAP_WIDTH = 1;
export const MUD_REPORT_HEADER_HEIGHT = 25;
export const WELL_INFO_HEIGHT = 25;
export const DRILL_STRING_HEIGHT = 30;
export const DRILL_STRING_WIDTH = 51;
export const CASING_DATA_HEIGHT = DRILL_STRING_HEIGHT;
export const CASING_DATA_WIDTH = 49;
export const BIT_DATA_HEIGHT = 18;
export const BIT_DATA_WIDTH = CASING_DATA_WIDTH + GAP_WIDTH + DRILL_STRING_WIDTH;
export const CIRC_VOL_WIDTH = 38;
export const CIRC_VOL_HEIGHT = 33;
export const PUMP_DATA_WIDTH = 63;
export const PUMP_DATA_HEIGHT = 33;
export const CIRC_DATA_WIDTH = CIRC_VOL_WIDTH + GAP_WIDTH + PUMP_DATA_WIDTH;
export const CIRC_DATA_HEIGHT = CASING_DATA_HEIGHT + BIT_DATA_HEIGHT - CIRC_VOL_HEIGHT;
export const MUD_PROP_SPEC_HEIGHT = 186;
export const MUD_PROP_SPEC_WIDTH = 55;
export const TOURLY_HEIGHT = 68;
export const TOURLY_WIDTH = 105;
export const SURVEY_HEIGHT = 24;
export const SURVEY_WIDTH = 42;
export const EXTERNAL_HEIGHT = 32;
export const EXTERNAL_WIDTH = SURVEY_WIDTH;
export const VOLUME_HEIGHT = 62;
export const VOLUME_WIDTH = SURVEY_WIDTH;
export const HYDRA_HEIGHT = 65;
export const HYDRA_WIDTH = SURVEY_WIDTH;
export const PRODUCT_HEIGHT = 80;
export const PRODUCT_WIDTH = TOURLY_WIDTH;
export const EBP_HEIGHT = 22;
export const EBP_WIDTH = TOURLY_WIDTH;
export const COST_HEIGHT = 13;
export const COST_WIDTH = TOURLY_WIDTH;

export const SOLIDS_HEIGHT = 38;
export const SOLIDS_WIDTH = 55;

export const RECAP_HEIGHT = SOLIDS_HEIGHT;
export const RECAP_WIDTH = FULL_WIDTH - SOLIDS_WIDTH - GAP_WIDTH;

export const ENGINEER_HEIGHT = 8;
export const ENGINEER_WIDTH = FULL_WIDTH;

export const FOOTER_HEIGHT = 7;
export const FOOTER_WIDTH = FULL_WIDTH;

export const WELL_INFO_TOP = PAGE_BORDER_WIDTH + MUD_REPORT_HEADER_HEIGHT + GAP_WIDTH;
export const DRILL_STRING_TOP = WELL_INFO_TOP + WELL_INFO_HEIGHT + GAP_WIDTH;
export const CASING_DATA_TOP = DRILL_STRING_TOP;
export const CASING_DATA_LEFT = PAGE_BORDER_WIDTH + DRILL_STRING_WIDTH + GAP_WIDTH;
export const BIT_DATA_TOP = DRILL_STRING_TOP + DRILL_STRING_HEIGHT + GAP_WIDTH;
export const CIRC_VOL_TOP = DRILL_STRING_TOP;
export const CIRC_VOL_LEFT = CASING_DATA_LEFT + CASING_DATA_WIDTH + GAP_WIDTH;
export const PUMP_DATA_TOP = DRILL_STRING_TOP;
export const PUMP_DATA_LEFT = CIRC_VOL_LEFT + CIRC_VOL_WIDTH + GAP_WIDTH;
export const CIRC_DATA_TOP = CIRC_VOL_TOP + CIRC_VOL_HEIGHT + GAP_WIDTH;
export const CIRC_DATA_LEFT = CIRC_VOL_LEFT;
export const MUD_PROP_SPEC_TOP = BIT_DATA_TOP + BIT_DATA_HEIGHT + GAP_WIDTH;
export const TOURLY_TOP = MUD_PROP_SPEC_TOP;
export const TOURLY_LEFT = PAGE_BORDER_WIDTH + MUD_PROP_SPEC_WIDTH + GAP_WIDTH;

export const HYDRA_TOP = MUD_PROP_SPEC_TOP;
export const HYDRA_LEFT = TOURLY_LEFT + TOURLY_WIDTH + GAP_WIDTH;

export const VOLUME_TOP = HYDRA_TOP + HYDRA_HEIGHT + GAP_WIDTH;
export const VOLUME_LEFT = HYDRA_LEFT;

export const EXTERNAL_TOP = VOLUME_TOP + VOLUME_HEIGHT + GAP_WIDTH;
export const EXTERNAL_LEFT = HYDRA_LEFT;

export const SURVEY_TOP = EXTERNAL_TOP + EXTERNAL_HEIGHT + GAP_WIDTH;
export const SURVEY_LEFT = HYDRA_LEFT;




export const PRODUCT_TOP = TOURLY_TOP + TOURLY_HEIGHT + GAP_WIDTH;
export const PRODUCT_LEFT = TOURLY_LEFT;
export const EBP_TOP = PRODUCT_TOP + PRODUCT_HEIGHT + GAP_WIDTH;
export const EBP_LEFT = TOURLY_LEFT;
export const COST_TOP = EBP_TOP + EBP_HEIGHT + GAP_WIDTH;
export const COST_LEFT = TOURLY_LEFT;
export const SOLIDS_TOP = MUD_PROP_SPEC_TOP + MUD_PROP_SPEC_HEIGHT + GAP_WIDTH;
export const RECAP_TOP = SOLIDS_TOP;
export const RECAP_LEFT = PAGE_BORDER_WIDTH + SOLIDS_WIDTH + GAP_WIDTH;
export const ENGINEER_TOP = SOLIDS_TOP + SOLIDS_HEIGHT + GAP_WIDTH;
export const FOOTER_TOP = ENGINEER_TOP + ENGINEER_HEIGHT + GAP_WIDTH;

export const ONE_THIRD_WIDTH = FULL_WIDTH / 3;
export const TWO_THIRD_WIDTH = FULL_WIDTH * 2 / 3;
export const SECTION_HEADER_HEIGHT = 5;

export const BIT_DATA_ROWS = 4;
export const WELL_INFO_ROWS = 6;
export const DRILL_STRING_ROWS = 7;
export const CASING_DATA_ROWS = 7;
export const CIRC_VOL_ROWS = 8;
export const PUMP_DATA_ROWS = 8;
export const MUD_PROP_SPEC_ROWS_OBM = 42;
export const MUD_PROP_SPEC_ROWS_WBM = 45;
export const SURVEY_ROWS = 5;
export const EXTERNAL_ROWS = 7;
export const VOLUME_ROWS = 11;
export const HYDRA_ROWS = 12;
export const PRODUCT_ROWS = 17;
export const EBP_ROWS = 5;
export const SOLIDS_ROWS = 8;


// WEBPACK FOOTER //
// ./src/Services/Pdf/MudReport/SpecMilsMud.ts